import "../scss/style.scss";
import "./swiper";
import MatchHeight from './matchHeight'; // 任意のディレクトリ

//smooth scroll
$(function () {
  var headerHeight = $('.header').outerHeight();
  var urlHash = location.hash;
  if (urlHash) {
    $('body,html').stop().scrollTop(0);
    setTimeout(function() {
      var target = $(urlHash);
      var position = target.offset().top - headerHeight;
      $('body,html').stop().animate({
        scrollTop: position
      }, 500);
    }, 100);
  }
	$('a[href^="#"]').click(function () {
		var headerH = $('.js-header').outerHeight();
		var href = $(this).attr("href");
		var target = $(href == "#" || href == "" ? "body" : href);
		var position = target.offset().top - headerH;
		$("html, body").animate({ scrollTop: position }, 800, "swing");
		return false;
	});
});

// pagetop
$(function(){
	$(window).scroll(function () {
		if($(this).scrollTop() >= 600) {
			$('.js-pagetop').fadeIn();
		} else {
			$('.js-pagetop').fadeOut();
		}
		var scrollHeight = $(document).height();
		var scrollPosition = $(window).height() + $(window).scrollTop();
		var footerHeight = $(".js-footer").innerHeight();
		if ( scrollHeight - scrollPosition  <= footerHeight - 45 ) {
			$(".js-pagetop").addClass('is-stop');
		} else {
			$(".js-pagetop").removeClass('is-stop');
		}
	});
});

// プルダウンボタン
document.addEventListener('DOMContentLoaded', function() {
  const pullDownButtons = document.querySelectorAll('.js-pulldown');
  for (const button of pullDownButtons) {
    button.addEventListener('click', function() {
      const content = button.nextElementSibling;
      content.classList.toggle('is_open');
      button.classList.toggle('is_open');
    });
  }
});

// プルダウンボタン
document.addEventListener('DOMContentLoaded', function() {
  const pullDownButtons = document.querySelectorAll('.js-sp-pulldown');
  for (const button of pullDownButtons) {
    button.addEventListener('click', function() {
      const content = button.nextElementSibling;
      content.classList.toggle('is_open');
      button.classList.toggle('is_open');
    });
  }
});

// フッターのスクロールによる非表示
const notice = document.querySelector('.fixBtn');
const footer = document.querySelector('.footer');

window.addEventListener('scroll', () => {
  if (footer.getBoundingClientRect().top < window.innerHeight) {
    notice.classList.add('is_hide');
  } else {
    notice.classList.remove('is_hide');
  }
});

new MatchHeight('.js-matchheight', 'body');

// ドロップダウンボタン
document.addEventListener('DOMContentLoaded', function() {
  const dropdownButtons = document.querySelectorAll('.js-dropdown');
  for (const button of dropdownButtons) {
    button.addEventListener('click', function() {
      const content = button.previousElementSibling;
      content.classList.toggle('is_open');
      button.classList.toggle('is_open');
    });
  }
});
